const SETTINGS = {
  emergencyPhoneNumber: '+31 88 112 1816'
}

export default SETTINGS
